import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { FormContentBlockerFieldIsVisual, FormContentBlockerFieldIsVisualDarkMode, FormContentBlockerFieldShouldForceToShowVisual, FormContentBlockerFieldVisualBlur, FormContentBlockerFieldVisualContentType, FormContentBlockerFieldVisualDownloadThumbnail, FormContentBlockerFieldVisualHeroButtonText, FormContentBlockerFieldVisualMediaThumbnail, FormContentBlockerFieldVisualType, FormContentBlockerLayout } from "../..";
import { useI18n } from "../../../../../contexts";
import { FormHeadline } from "../../..";
const FormContentBlockerFieldVisualCompose = (param)=>{
    let { visualMediaThumbnailPicker } = param;
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.criteria !== nextValues.criteria,
        children: (param)=>{
            let { getFieldValue } = param;
            const criteria = getFieldValue("criteria");
            return criteria === "services" && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(FormHeadline, {
                        offset: FormContentBlockerLayout.labelCol.span,
                        description: __("For each content blocker it can be defined if it should be visually visible. This means that if the user has not agreed to the respective services, a box with a button is displayed to adjust the privacy settings so that the actual content can be loaded. The design of the box is copied from the cookie banner."),
                        children: __("Visual")
                    }),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldIsVisual, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualType, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualContentType, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldIsVisualDarkMode, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualDownloadThumbnail, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualMediaThumbnail, {
                        children: visualMediaThumbnailPicker
                    }),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualBlur, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldVisualHeroButtonText, {}),
                    /*#__PURE__*/ _jsx(FormContentBlockerFieldShouldForceToShowVisual, {})
                ]
            });
        }
    });
};
export { FormContentBlockerFieldVisualCompose };
